<template>
  <div v-if="savedGames.length > 0" class="box has-background-grey-darker mb-4">
    <h1 class="title is-size-4 has-text-warning">Saved Games</h1>
    <p class="mb-3">Resume a saved game or delete old entries.</p>
    <div v-for="(gm, idx) in savedGames" :key="gm.Guid" class="columns is-mobile is-vcentered mb-2" style="border-bottom: 1px solid #444; padding-bottom: 5px;">
      <div class="column is-narrow">
        <i class="fas fa-bullseye has-text-warning fa-lg"></i>
      </div>
      <div class="column">
        <span class="has-text-weight-bold">{{ gm.title }}</span> <span class="tag is-dark">{{ gm.gameType }}</span>
        <br/>
        <span class="is-size-7 has-text-grey-light">{{ gm.dateTimeStamp | formatDateTime }}</span>
      </div>
      <div class="column is-narrow">
        <div class="buttons are-small">
          <a class="button is-success is-inverted" @click="$emit('resume', gm)" title="Resume">
            <span class="icon"><i class="fas fa-play"></i></span>
          </a>
          <a class="button is-danger is-inverted" @click="$emit('delete', gm)" title="Delete">
            <span class="icon"><i class="fas fa-trash"></i></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SavedGames',
  props: {
    savedGames: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
/* Component-specific styles can be added here if needed */
</style>
